import type { Action } from 'redux';

import type { OcpsPolicy, OcpsPolicyData, OcpsRequestError } from '../../state/ocps/types';

export interface OcpsPolicyResponseValue {
  readonly priority: number;
  readonly policiesPayload: OcpsPoliciesPayload[];
}

export interface OcpsPoliciesPayload {
  readonly settingId: string;
  readonly value: string;
}

export interface OcpsPolicyRequestResponse {
  readonly policiesHash: string;
  readonly value: OcpsPolicyResponseValue[] | null;
  readonly checkInTime: string;
}

export interface LoadOcpsPolicyDataPendingAction extends Action {
  readonly type: 'OCPS_POLICIES.LOAD_PENDING';
}

export interface LoadOcpsPolicyDataFulfilledAction extends Action {
  readonly type: 'OCPS_POLICIES.LOAD_FULFILLED';
  readonly payload: OcpsPolicyData;
}

export interface LoadOcpsPolicyDataRejectedAction extends Action {
  readonly type: 'OCPS_POLICIES.LOAD_REJECTED';
  readonly payload: OcpsRequestError;
  readonly error: true;
}

export interface ClearOcpsPolicyDataAction extends Action {
  readonly type: 'OCPS_POLICIES.CLEAR';
}

export const OcpsPolicySettingIds = {
  SendFeedback: 'office16;L_SendFeedback',
  SendSurvey: 'office16;L_SendSurvey',
  ConnectedExperiences: 'office16;L_ConnectedOfficeExperiences',
  Screenshot: 'office16;L_Screenshot',
  LogCollection: 'office16;L_LogCollection',
  EmailCollection: 'office16;L_EmailCollection',
};

export const OcpsPolicySettingMap: Record<string, OcpsPolicy> = {
  [OcpsPolicySettingIds.SendFeedback]: 'UserFeedbackFormEnabled',
  [OcpsPolicySettingIds.SendSurvey]: 'SurveyFeedbackFormEnabled',
  [OcpsPolicySettingIds.ConnectedExperiences]: 'ConnectedExperiencesEnabled',
  [OcpsPolicySettingIds.Screenshot]: 'AllowScreenshots',
  [OcpsPolicySettingIds.LogCollection]: 'AllowLogCollection',
  [OcpsPolicySettingIds.EmailCollection]: 'AllowEmailCollection',
};

export const OcpsFeedbackPolicyEnabled = '1';

export type LoadOcpsPolicyDataAction =
  | LoadOcpsPolicyDataPendingAction
  | LoadOcpsPolicyDataFulfilledAction
  | LoadOcpsPolicyDataRejectedAction
  | ClearOcpsPolicyDataAction;
